package com.cybersoftsolution.cybersoftsolutionweb.components.capcha

import androidx.compose.runtime.*
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.utils.BorderBoxSizeElementObserver
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.css.boxShadow
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.*
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.document
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.attributes.max
import org.jetbrains.compose.web.attributes.min
import org.jetbrains.compose.web.attributes.step
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLInputElement

fun generateRandomButtonInitialPosition(): Int {
    return (5..95).random()
}

fun Float.verifyPosition(targetPosition: Int, tolerance: Float): Boolean {
    return this in (targetPosition - tolerance) ..(targetPosition + tolerance).toFloat()
}

@Composable
fun SliderCaptchaBootstrap(
    verified: Boolean = false,
    modifier: Modifier = Modifier,
    hintText: String = "Usa tu instinto y demuestra que no eres un robot",
    id : String = "sliderCaptcha",
    useErrorMessages: Boolean = true,
    onVerified: () -> Unit,
    onError: (String) -> Unit
) {


    val markDiameter = 34.px // Diámetro de la marca circular (ajustado)
    val avoidTolerance = 5 //

    // Modified function to generate a random target position different from currentButtonPositionToAvoid
    fun generateRandomTargetPosition(currentButtonPositionToAvoid: Float): Int {
        var newTargetPosition: Int
        do {
            newTargetPosition = (5..95).random()
        } while (currentButtonPositionToAvoid in (newTargetPosition - avoidTolerance).toFloat() ..(newTargetPosition + avoidTolerance).toFloat())
        return newTargetPosition
    }

    val breakpoint = rememberBreakpoint()

    var buttonPosition by remember { mutableStateOf(generateRandomButtonInitialPosition().toFloat()) }
    var verificationStatus by remember { mutableStateOf<CaptchaStatus>( if (verified) CaptchaStatus.Success else CaptchaStatus.Pending) }
    var targetPosition by remember { mutableStateOf(if (verified) buttonPosition.toInt() else generateRandomTargetPosition( buttonPosition ) ) }
    var statusMessage by remember { mutableStateOf(" ") }
    var sliderWidth by remember { mutableStateOf(0) }
    val sliderHeight = 40.px


    val markBorderWidth = 5.px // Ancho del borde rojo
    val tolerance = 0.5f


    LaunchedEffect(verified){
        if (!verified){
            verificationStatus = CaptchaStatus.Pending
        }
    }

    LaunchedEffect(Unit,breakpoint) {

        //Obtener el ancho del elemento por primera vez
        sliderWidth = (document.getElementById(id) as? HTMLDivElement)?.offsetWidth ?: 0


        //Observar el ancho del elemento
        BorderBoxSizeElementObserver.observeElementById(id)

        BorderBoxSizeElementObserver.widthChangeFlow.collect { (id, elementWidth) ->
            when (id) {
                id -> {
                    sliderWidth = elementWidth
                }

            }
        }

    }



//     ... DisposableEffect para dejar de observar el ancho del elemento
    DisposableEffect(Unit) {
        onDispose {
            BorderBoxSizeElementObserver.unObserveElementById(id)
        }
    }



    LaunchedEffect(verificationStatus) {
        when (verificationStatus) {
            CaptchaStatus.Pending -> {
                targetPosition = generateRandomTargetPosition(currentButtonPositionToAvoid = (document.getElementById(id) as HTMLInputElement).value.toFloat())
            }
            CaptchaStatus.Success -> {
                statusMessage = "Verificación Exitosa!"
                onVerified()
            }
            CaptchaStatus.Failed -> {
                statusMessage = "Posición incorrecta. Intentelo de nuevo."
                onError(statusMessage)
                verificationStatus = CaptchaStatus.Pending
            }
        }
    }



    Box(
        modifier = Modifier
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .alignItems(AlignItems.Center)
            .fillMaxWidth()
            .then(modifier)

    ) {
        SpanText(
            text = if (useErrorMessages) hintText else {
                when (verificationStatus) {
//                    CaptchaStatus.Pending -> "Usa tu instinto y demuestra que no eres un robot"
                    CaptchaStatus.Success -> "Verificación Exitosa!"
                    else -> hintText
//                    CaptchaStatus.Failed -> "Posición incorrecta. Intentelo de nuevo."
                }
            },
            modifier = Modifier
                .margin(bottom = 10.px)
                .thenIf(
                    condition = verificationStatus == CaptchaStatus.Success,
                    other = Modifier
                        .color(Colors.Green)
                )
                .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
        )

        // Contenedor principal del slider (para posicionamiento relativo de la marca)
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .position(Position.Relative) // Necesario para posicionar la marca relativa a este contenedor
        ) {
            // Marca objetivo
            Box(
                modifier = Modifier
                    .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
                    .position(Position.Absolute)
                    .left(
                        (getPositionInPx(targetPosition, sliderWidth.px, markDiameter / 2)).value.px
                    ) // Ajuste con markDiameter
                    .top((sliderHeight - markDiameter) / 2) // Centra verticalmente el círculo
                    .size(markDiameter) // Define el diámetro del círculo
                    .borderRadius(50.percent) // Hace que sea un círculo
                    .border(
                        width = markBorderWidth,
                        style = LineStyle.Solid,
                        color = Theme.Blue.rgb
                    ) //
                    .backgroundColor(Colors.Transparent) // Fondo transparente
                    .thenIf(
                        condition = verificationStatus == CaptchaStatus.Success,
                        other = Modifier
                            .backgroundColor(Theme.Blue.rgb)
                            .scale(1.2)

                    )

            )

            // **Componente Range de Bootstrap**
            Input(
                type = InputType.Range,

                attrs = Modifier
                    .fillMaxWidth()

                    .disabled(if (verificationStatus==CaptchaStatus.Success) true else false)
                    .toAttrs


                {
//                    margin(8.px)
                    classes("form-range") // Clase de Bootstrap para el estilo de 'range'
                    id(id)
                    style {
//                        width(sliderWidth) // Ancho del slider (debe ser el mismo que el contenedor padre)
                        height(sliderHeight) // Ajusta la altura si es necesario
                        // Elimina estilos por defecto del input range para que Bootstrap controle el estilo
                        property("appearance", "none")
                        property("-webkit-appearance", "none")
                        property("-moz-appearance", "none")
                        backgroundColor(Colors.Transparent) // Fondo transparente para que se vea el estilo de Bootstrap
                        marginLeft(0.px) // Ajustes para alinear con la marca roja si es necesario
                        marginRight(0.px)



//                        backgroundColor(Colors.Yellow) // $form-range-bg - Usando Color.Yellow como aproximación)  // $form-range-track-bg - Usando Color.LightGray como aproximación
                        borderRadius(45.px) // $form-range-track-border-radius
//                        boxShadow(
//                            offsetX = 0.px,
//                            offsetY = 0.px,
//                            blurRadius = 3.px,
//                            spreadRadius = 3.px,
//                            color = if (verificationStatus!=CaptchaStatus.Success) Theme.Blue.rgb else Theme.Black.rgb
////                            color = Theme.Blue.rgb
//                        )

                    }
                    defaultValue(buttonPosition.toString())
//                    value(buttonPosition.toString()) // Establece el valor inicial del input range
                    min("0")
                    max("100")
                    step(0.1)
                    onChange { event ->
                        buttonPosition =  (document.getElementById(id) as HTMLInputElement).value.toFloat()

                        if (buttonPosition.verifyPosition(targetPosition, tolerance)) {
                            verificationStatus = CaptchaStatus.Success
                        } else {
//                            (document.getElementById(id) as HTMLInputElement).value = "$buttonPosition" not work
                            verificationStatus = CaptchaStatus.Failed
                        }
                    }


                },
            )
        }

        if (useErrorMessages){
            SpanText(
                text = statusMessage,
                modifier = Modifier
                    .margin(top = 10.px)
                    .color(Colors.Red)
                    .thenIf(
                        condition = verificationStatus == CaptchaStatus.Success,
                        other = Modifier
                            .color(Colors.Green)
                    )
            )
        }


    }
}


private fun getPositionInPx(position: Int, sliderWidth: CSSUnitValue, offset: CSSUnitValue): CSSUnitValue {
    return ((position.toFloat() / 100) * sliderWidth.value - offset.value).px
}


private fun calculatePositionFromMouseX(mouseX: Double, sliderWidth: CSSUnitValue): Int {
    return ((mouseX / sliderWidth.value) * 100).toInt()
}

enum class CaptchaStatus {
    Pending,
    Success,
    Failed
}